import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/services/api.service';
import { CredentialsService } from 'src/app/core';
import { CompanyRegistrationDashboardStatistics } from './DashboardStatistics';
import { LoginContext } from 'src/services/login-context.model';
import { ActivatedRoute, Router } from '@angular/router';
import { clearLocalStorage } from '../service/clear-localstorage';
import { AppComponent } from 'src/app/app.component';
import { clearSessionStorage } from '../service/clear-sessionstorage';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { RolePrivilegeManagerService } from 'src/services/service/role-privilege-manager.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  companyRegistrationStatistics: CompanyRegistrationDashboardStatistics;
  loadingCR: boolean;
  activeLink:string = "";
  profile: LoginContext | null;
  role: any;
  noPrivilege: boolean =false;
  postIncLoader: boolean;
  newEntryLoader: boolean;
  updateLoader: boolean;
  escalatedAppLoader: boolean;
  errorStatus: boolean = false;
  postIncStat$: Observable<any>;
  loader: string = './loading.gif';
  canUpdateCompany = false;
  poratlUserRole: any[]  = [];
  canUpdateRegDateAndRcNumber = false;
  POST_DATA_ENTRY = this.rolePrivilegeManager.postDataEntry();
  PRE_DATA_ENTRY = this.rolePrivilegeManager.postDataEntry();
  SUPERVISOR = this.rolePrivilegeManager.supervisor();

  constructor(private apiService: ApiService,
              private router: Router,
              private route: ActivatedRoute,
              private credentialsService: CredentialsService,
              private app:AppComponent,
              private spinner: NgxSpinnerService,
              private rolePrivilegeManager:RolePrivilegeManagerService) {
    this.fetchCompanyRegistrationDashboardStatistics();
    this.profile = this.credentialsService.credentials;
    clearLocalStorage();
    sessionStorage.removeItem('activeSupervior')
    clearSessionStorage();
    this.checkPrivilege();
    this.role = this.app.currentRole;

    this.activeLink = this.router.url;
    if (this.activeLink=="" || this.activeLink=="/"){
      this.route.url.subscribe(response => {
        this.activeLink = response[0]['path'];
      });
    }

    this.postIncStat$ = this.apiService.get_(`/post-inc-escalation/count/${this.profile.user.id}`)
      .pipe(map((response:any) => response.data)),
      catchError(() =>of({supervisorCount: 0, dataEntryCount: 0, approvedCount: 0}));
    this.poratlUserRole = JSON.parse(sessionStorage.getItem('PortalUserRole'));

  }

  ngOnInit(): void {
    this.poratlUserRole.forEach(item => {
      if (item.includes('CAC_CRP_DATA_ENTRY_UPDATE')){
        this.canUpdateCompany = true;
        localStorage.setItem('canUpdateCompany', JSON.stringify(this.canUpdateCompany));
      }
      if (item.includes('CAC_CRP_DATA_ENTRY_RC_REG_NUMBER_UPDATE')){
        this.canUpdateRegDateAndRcNumber = true;
        localStorage.setItem('canUpdateRegDateAndRcNumber', JSON.stringify(this.canUpdateRegDateAndRcNumber));
      }
    });

    sessionStorage.removeItem('activeSupervior');
    this.spinner.show();
  }

  checkPrivilege(): void {
    if(!(this.POST_DATA_ENTRY || this.PRE_DATA_ENTRY)) {
      this.noPrivilege=true
    }
  }

  fetchCompanyRegistrationDashboardStatistics(): void {
    this.loadingCR = true;
    this.apiService.get_("/post-payment/fetch/total-count").subscribe(
      r => {
        this.companyRegistrationStatistics = <CompanyRegistrationDashboardStatistics>r
        this.loadingCR = false;
      },
      err =>{
        this.loadingCR =false
        this.errorStatus = true;
        this.companyRegistrationStatistics = {
          notSubmitted : -1,
          pending : -1,
          queried : -1,
          approved : -1,
          escalatedApp: -1
        }
      }
    );
  }

  postInc(): void {
    this.postIncLoader=true
  }
  newEntry(): void {
    this.newEntryLoader=true
  }

  update(): void {
    this.updateLoader=true
  }

  escalated(): void {
    this.escalatedAppLoader=true
  }

}
